import { PengelolaanKinerjaTimeline } from 'app/KinerjaShared/components/PengelolaanKinerjaTimeline'
import CardPanduan from 'app/KinerjaShared/components/CardPanduan'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { PerencanaanPegawaiCard } from 'app/KinerjaPamongPage/components/perencanaan/PerencanaanPegawaiCard'
import { PerencanaanKemudahanSurveyCard } from 'app/KinerjaPamongPage/components/perencanaan/PerencanaanKemudahanSurveyCard'
import { PelaksanaanPegawaiCard } from 'app/KinerjaPamongPage/components/pelaksanaan/PelaksanaanPegawaiCard'
import { PelaksanaanKemudahanSurveyCard } from 'app/KinerjaPamongPage/components/pelaksanaan/PelaksanaanKemudahanSurveyCard'

export function Homepage() {
  return (
    <div className="flex w-full min-h-screen">
      <div className="flex-shrink-0 min-h-full">
        <div className="w-64">{/* Sentinel element for sidebar spacing */}</div>
        <KinerjaSidebar activeMenu="pamong-pegawai" sticky />
      </div>
      <main className="space-y-6 p-6 overflow-hidden">
        <div className="flex items-start">
          <div className="w-full space-y-6">
            <PerencanaanPegawaiCard />
            <PelaksanaanPegawaiCard />
          </div>
          <div className="space-y-6">
            <PerencanaanKemudahanSurveyCard className="ml-6 w-72 lg:w-80 xl:w-96" />
            <PelaksanaanKemudahanSurveyCard className="ml-6 w-72 lg:w-80 xl:w-96" />
          </div>
        </div>
        <PengelolaanKinerjaTimeline
          timeline={[
            {
              title: 'Januari',
              steps: ['Perencanaan Kinerja'],
            },
            {
              title: 'Februari - November',
              steps: [
                'Persiapan Praktik Kinerja',
                'Pelaksanaan Observasi Praktik Kinerja',
                'Pelaksanaan Tindak Lanjut Praktik Kinerja',
              ],
            },
            {
              title: 'Desember',
              steps: ['Penetapan Predikat Kinerja'],
            },
          ]}
        />

        <CardPanduan />
      </main>
    </div>
  )
}
